import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Loader2, Shield, Lock } from 'lucide-react';

export const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simple admin authentication (in production, use proper auth)
    if (credentials.username === 'admin' && credentials.password === 'fudco@2025') {
      localStorage.setItem('fudco_admin', 'true');
      toast.success('Welcome, Admin!');
      navigate('/admin/dashboard');
    } else {
      toast.error('Invalid credentials');
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4" data-testid="admin-login-page">
      <Card className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="bg-[#2D8B2E] text-white p-4 rounded-2xl inline-block mb-4">
            <Shield className="w-10 h-10" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Admin Panel
          </h1>
          <p className="text-gray-600 text-sm mt-2">Fudco Partner Management</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="username">Username</Label>
            <Input
              id="username"
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              placeholder="Enter username"
              required
              className="h-12 rounded-xl"
              data-testid="admin-username"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <div className="relative">
              <Input
                id="password"
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                placeholder="Enter password"
                required
                className="h-12 rounded-xl"
                data-testid="admin-password"
              />
              <Lock className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-[#2D8B2E] hover:bg-[#236c24] text-white rounded-full font-semibold"
            data-testid="admin-login-btn"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Login to Admin Panel'}
          </Button>
        </form>

        <p className="text-center text-xs text-gray-400 mt-6">
          Authorized personnel only
        </p>
      </Card>
    </div>
  );
};
